import React, { Fragment } from "react";

const YomTierRepeater = ({
  tiers,
  aircraftTypeId,
  aircraftTypeName,
  onAdd,
  onRemove,
  onChange,
  maxTiers = 4,
}) => {
  const toPercentageDisplay = (decimal) => {
    if (decimal === null || decimal === undefined || decimal === "") return "";
    return (decimal * 100).toFixed(2);
  };

  const handleFieldChange = (tierIndex, field, value) => {
    let processedValue = value;
    
    // Convert percentage input to decimal for adjustment field
    if (field === "adjustment") {
      processedValue = value === "" ? 0 : parseFloat(value) / 100;
    } else if (field === "year") {
      processedValue = value === "" ? null : parseInt(value);
    }
    
    onChange(aircraftTypeId, tierIndex, field, processedValue);
  };

  return (
    <div className="ctf-yom-repeater">
      {tiers && tiers.length > 0 ? (
        <div className="ctf-yom-tiers">
          {tiers.map((tier, index) => (
            <div key={index} className="ctf-yom-tier">
              <div className="ctf-form-group">
                <label htmlFor={`year-${aircraftTypeId}-${index}`}>Year</label>
                <input
                  type="number"
                  id={`year-${aircraftTypeId}-${index}`}
                  min="1980"
                  max="2030"
                  value={tier.year || ""}
                  placeholder="e.g., 2004"
                  onChange={(e) =>
                    handleFieldChange(index, "year", e.target.value)
                  }
                />
              </div>

              <div className="ctf-form-group">
                <label htmlFor={`commonlyAvailable-${aircraftTypeId}-${index}`}>
                  Commonly Available Aircraft
                </label>
                <input
                  type="text"
                  id={`commonlyAvailable-${aircraftTypeId}-${index}`}
                  value={tier.commonlyAvailable || ""}
                  placeholder="e.g., Citation X, G450"
                  onChange={(e) =>
                    handleFieldChange(index, "commonlyAvailable", e.target.value)
                  }
                />
              </div>

              <div className="ctf-form-group">
                <label htmlFor={`adjustment-${aircraftTypeId}-${index}`}>
                  Adjustment %
                </label>
                <div className="ctf-percentage-input">
                  <input
                    type="number"
                    id={`adjustment-${aircraftTypeId}-${index}`}
                    step="0.01"
                    value={toPercentageDisplay(tier.adjustment)}
                    placeholder="e.g., 10 or -3"
                    onChange={(e) =>
                      handleFieldChange(index, "adjustment", e.target.value)
                    }
                  />
                  <span className="ctf-percentage-symbol">%</span>
                </div>
                <small className="ctf-helper-text">
                  Enter as percentage (e.g., 10 for 10% increase, -3 for 3% decrease)
                </small>
              </div>

              <button
                type="button"
                className="ctf-btn ctf-btn-danger ctf-btn-remove"
                onClick={() => onRemove(aircraftTypeId, index)}
              >
                Remove
              </button>
            </div>
          ))}
        </div>
      ) : (
        <p className="ctf-no-tiers">No YOM tiers configured for this aircraft type.</p>
      )}

      {(!tiers || tiers.length < maxTiers) && (
        <button
          type="button"
          className="ctf-btn ctf-btn-secondary"
          onClick={() => onAdd(aircraftTypeId)}
        >
          + Add Tier
        </button>
      )}
    </div>
  );
};

export default YomTierRepeater;

